import React from 'react';
import SidebarDropDownOption from '../../../../components/SidebarDropDownOption';
import SubMenu from '../../../../components/Sidebar/SubMenu';
import EmployeeTabsApp from "../Functionality/EmployeeTabsApp";
import {STATUS_MODEL} from "../../../../enums/statusEnum";
import CommonTabsApp from "../Functionality/CommonTabsApp";
import DropDownMenuItem from "../../../../components/DropDown/DropDownMenuItem";
import {POSITION_MODEL} from "../../../../Helpers/PositionModel";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 * EmployeeTabs Component renders the sidebar menu items based on user permissions
 * and development mode. It also handles submenu toggle functionality and menu style changes.
 *
 * @param {boolean} isMenuOpen - Determines if the sidebar menu is in expanded mode.
 * @returns {JSX.Element}
 */
const EmployeeTabs = ({ isMenuOpen }) => {
    const props = CommonTabsApp();
    const {DEV, user, openMenu, changeStyle, setChangeStyle, isHovering, setIsHovering,
        handleMenuToggle, handleMenuItemClick, handleClose} = props;

    const {menuItems} = EmployeeTabsApp(props);

    return (
        <ul className={isMenuOpen ? 'largeMenu' : 'shortMenu'}>
            {user?.data?.status?.id !== STATUS_MODEL.TO_APPROVE_DOCUMENT && (
                <>
                    {menuItems
                        .filter((item) => DEV || item.hasPermission)
                        .map((item, index) => (
                            <SubMenu
                                key={index}
                                name={item.name}
                                isMenuOpen={isMenuOpen}
                                url={item.url}
                                isHovering={isHovering}
                                numHovering={item.isHovering}
                                label={item.label}
                                menuId={`menu-${index}`}
                                openMenu={openMenu}
                                handleMenuToggle={handleMenuToggle}
                                setChangeStyle={setChangeStyle}
                                onClick={() => handleMenuItemClick(item.name)}
                                changeStyle={changeStyle}
                                Icon={item.icon}
                                onLeave={() => setIsHovering(0)}
                                onHover={() => setIsHovering(item.isHovering)}
                                onlyName={item.onlyName}
                            >
                                {item.itemsSubMenu &&
                                    item.itemsSubMenu.map((subItem, subIndex) => (
                                        <DropDownMenuItem
                                            index={subIndex}
                                            name={subItem.name}
                                            handleClose={handleClose}
                                            icon={subItem.icon}
                                            url={subItem.url}
                                            iconPosition={POSITION_MODEL.LEFT}
                                        />
                                    ))
                                }
                            </SubMenu>
                        ))}
                </>
            )}
            <li className={isMenuOpen ? 'profile_li' : 'profile_li_col'}>
                <SidebarDropDownOption
                    changestyle={changeStyle}
                    hovereffect={isHovering}
                    isMenuOpen={isMenuOpen}
                    menutop={false}
                />
            </li>
        </ul>
    );
};

export default EmployeeTabs;
